/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { UserRequest } from '../models/UserRequest';
import type { UserResource } from '../models/UserResource';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UserService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Lister les administrateurs
     * Les comptes administrateurs Solis, non rattaches a une entreprise.
     * @param sortBy
     * @param sortDesc
     * @returns UserResource Array of `UserResource`
     * @throws ApiError
     */
    public adminUsersIndex(
        sortBy?: string,
        sortDesc?: boolean,
    ): CancelablePromise<Array<UserResource>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/users',
            query: {
                'sortBy': sortBy,
                'sortDesc': sortDesc,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Creer un administrateur
     * `email`, `name`, `roles`, `password` optionnel : **sans mot de passe, un e-mail de reinitialisation est envoye** pour qu'il choisisse le sien.
     * @param requestBody
     * @returns UserResource `UserResource`
     * @throws ApiError
     */
    public adminUsersStore(
        requestBody: UserRequest,
    ): CancelablePromise<UserResource> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/admin/users',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Detail d'un administrateur
     * @param id
     * @returns UserResource `UserResource`
     * @throws ApiError
     */
    public adminUsersShow(
        id: string,
    ): CancelablePromise<UserResource> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/admin/users/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
    /**
     * Modifier un administrateur
     * Mise a jour partielle ; `password` n'est change que s'il est envoye. `roles` **remplace** les roles existants. 404 `{ message }` s'il n'existe pas.
     * @param userId
     * @param requestBody
     * @returns UserResource `UserResource`
     * @throws ApiError
     */
    public adminUsersUpdate(
        userId: string,
        requestBody: UserRequest,
    ): CancelablePromise<UserResource> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
                422: `Erreur de validation`,
            },
        });
    }
    /**
     * Supprimer un administrateur
     * Renvoie le compte supprime ; 404 `{ message }` s'il n'existe pas.
     * @param userId
     * @returns UserResource `UserResource`
     * @throws ApiError
     */
    public adminUsersDestroy(
        userId: string,
    ): CancelablePromise<UserResource> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/admin/users/{user_id}',
            path: {
                'user_id': userId,
            },
            errors: {
                401: `Token absent, invalide, ou d'un type non accepte par ce endpoint.`,
                403: `Token valide mais sans droit sur ce endpoint, ou entreprise differente de celle du token.`,
            },
        });
    }
}
